import setClientDetails from './setClientDetails';
import setCurrent from './setCurrent';

export default {
  setClientDetails,
  setCurrent,
};
